<template>
  <div class="card-form">
    <page-main
      :tableData="tableData"
      :loading="loading"
      :tablePage="page"
      @reload="reload"
      @showDetail="showDetail"
    >
      <page-header
        ref="header"
        slot="header"
        @query="getData"
        @reset="resetPage"
        @openSynchronizeOrder="openSynchronizeOrder"
      >
        <b-button
          v-if="allow('S')"
          size="sm"
          class="ml-2"
          variant="outline-primary"
          @click="openSynchronizeOrder"
        >
          {{ $l('btn_text_synchronize_order') || '同步订单' }}
        </b-button>
        <b-button
          v-if="allow('IS')"
          size="sm"
          class="ml-2"
          variant="outline-success"
          @click="openImportOrder"
        >
          {{ $l('btn_import') || '导入订单' }}
        </b-button>
      </page-header>
      <pagination
        slot="pager"
        :current-page="page.curPage"
        :page-size="page.pageSize"
        :page-total="page.pageTotal"
        @change="handlePaginationChange"
      />
    </page-main>
    <Detail
      :visible.sync="detailVisible"
      :platformOrderCode="platformOrderCode"
    />
    <SynchronizeOrder :visible.sync="synchronizeOrder" @reload="reload" />
    <ImportOrder v-if="importOrder" :visible.sync="importOrder" @confirm="onUploadImportOrder" />
  </div>
</template>
<script>
import PageHeader from './header'
import PageMain from './main.vue'
import Detail from '../detail'
import SynchronizeOrder from '../synchronize-order'
import ImportOrder from '../import-order'
import { VXETable } from 'vxe-table'
import BaseTable from '@/mixins/base-table'
import EditLoading from '@/mixins/edit-loading'
export default {
  mixins: [BaseTable, EditLoading],
  components: { PageMain, PageHeader, Detail, SynchronizeOrder, ImportOrder },
  data() {
    return {
      usePage: true,
      detailVisible: false,
      platformOrderCode: '',
      synchronizeOrder: false,
      importOrder: false,
    }
  },
  methods: {
    getData(form) {
      this.loading = true
      this.$api
        .ecomPlatformOrderListApi({ ...form, ...this.page })
        .then((res) => {
          this.loading = false
          this.setData(res)
        })
        .catch(() => {
          this.loading = false
        })
    },
    openSynchronizeOrder() {
      this.synchronizeOrder = true
    },
    openImportOrder() {
      this.importOrder = true
    },
    showDetail(platformOrderCode) {
      this.detailVisible = true
      this.platformOrderCode = platformOrderCode
    },
    async importSPSTargetOrder() {
      const { file } = await VXETable.readFile({
        types: ['csv', 'CSV'],
      }).catch(() => ({}))
      if (!file) return

      if (this.loadingOpen()) return
      const res = await this.$api
        .ecomPlatformOrderImportSPSTargetApi(file)
        .catch(() => null)
      this.loadingClose()

      if (!res) return
      const { status } = res
      if (200 !== status) {
        this.$message.error(this.$l('tips_error_import_no') || '导入失败 !')
        return
      }

      this.$message({
        showClose: true,
        message: this.$l('tips_error_import_ok') || '导入成功 !',
        type: 'success',
      })

      this.reload()
    },
    async onUploadImportOrder (data) {
      if (this.loadingOpen()) return
      const res = await this.$api
        .ecomPlatformOrderImportOrderApi(data)
        .catch(() => null)
      this.loadingClose()

      if (!res) return
      const { status } = res
      if (200 !== status) {
        this.$message.error(this.$l('tips_error_import_no') || '导入失败 !')
        return
      }

      this.$message({
        showClose: true,
        message: this.$l('tips_error_import_ok') || '导入成功 !',
        type: 'success',
      })

      this.reload()
    }
  },
}
</script>
